import styled from 'styled-components';

export const Fieldset = styled.fieldset`
	box-sizing: border-box;
	flex: 1;
	border-radius: 12px;
	padding: 12px;
	display: flex;
	width: 100%;
	border: 1px solid #ced4da;
	margin: 0;

	&:focus-within {
		border-color: ${({ theme }) => theme.colors.primary.medium};
	}

	> span {
		width: 150px;
	}

	> .react-datepicker-wrapper {
		width: 100%;

		& input {
			font-family: 'Roboto', sans-serif;
			text-align: center;
			border: 0px;
			width: 100%;
    		height: 100%;
		}
	}
`;
